import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityContactService} from '../../../shared/services/university-contact.service';
import {UniversityService} from '../../../shared/services/university.service';

import {UtilsService} from '../../../shared/services/utils.service';
@Component({
    selector: 'app-university-contact',
    templateUrl: './university-contact.component.html',
    styleUrls: ['./university-contact.component.scss']
})
export class UniversityContactComponent implements OnInit {
    public data: any;
    public map: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    submitting: any = false;
    submitted: any = false;
    dataExists: any = false;
    university: any;

    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityContactService: UniversityContactService,
                private universityService: UniversityService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.getUniversityContactDetail();
            }
        });
    }

    getUniversityContactDetail() {
        this.universityContactService.detailByAdmin(this.universityId).subscribe(data => {
            if (data && data['info']) {
                this.data = data['info'];
                this.map = data['map'];
                this.dataExists = true;
            } else {
                this.dataExists = false;
            }
        });
    }

    submit() {
        let params = {
            'info': this.data ? UtilsService.encodeHtml(this.data) : '',
            'map': this.map ? this.map : '',
        };
        if (this.dataExists) {
            this.universityContactService.updateByAdmin(this.universityId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        } else {
            this.universityContactService.createByAdmin(this.universityId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}

